<script>

import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import UsersManagement from '@components/roles_management/users/UsersManagement'


export default {
  page: {
    title: 'Usuarios',
    meta: [{ name: 'Users management', content: 'Users management' }],
  },
  components: { Layout, PageHeader, UsersManagement },
  data() {
    return {
      title: this.$t('users'),
      items: [
        {
          text: this.$t('home'),
          href: '/',
        },
        {
          text: this.$t('management'),
        },
        {
          text: this.$t('users'),
          active: true,
        },
      ],

    }
  },
  validations: {
    
  },
  computed: {

  },
  methods: {

  }
    
}
</script>

<template> 
  <Layout>
    <PageHeader
      :title="title"
      :items="items"
    />
    <b-container fluid class="p-0">
      <b-row>
        <b-card class="w-100">
    <b-tabs pills card justified lazy >
      <b-tab title="Usuarios" active>
        <UsersManagement
        :admon_section="true"
        :create_user="true"

        />
      </b-tab>
      <b-tab title="Asociados a Terceros">
        <UsersManagement
        :isthirdpartyuser="true"
        :admon_section="true"
        />
      </b-tab>
    </b-tabs>
  </b-card>

      </b-row>
    </b-container>

  </Layout>
</template>
